import { default as bijbelG276XTKUFiMeta } from "/vercel/path0/bible-assistant/pages/bijbel.vue?macro=true";
import { default as chatdYO1V9nj87Meta } from "/vercel/path0/bible-assistant/pages/chat.vue?macro=true";
import { default as compare_45modelsaIpYM6owMLMeta } from "/vercel/path0/bible-assistant/pages/compare-models.vue?macro=true";
import { default as feedbackmHcH3RsfWFMeta } from "/vercel/path0/bible-assistant/pages/feedback.vue?macro=true";
import { default as indexbbHPdvO9QxMeta } from "/vercel/path0/bible-assistant/pages/index.vue?macro=true";
import { default as overkW9jEkzz7RMeta } from "/vercel/path0/bible-assistant/pages/over.vue?macro=true";
import { default as test1cOkiTlZOsMeta } from "/vercel/path0/bible-assistant/pages/test.vue?macro=true";
export default [
  {
    name: bijbelG276XTKUFiMeta?.name ?? "bijbel___nl-NL",
    path: bijbelG276XTKUFiMeta?.path ?? "/bijbel",
    meta: bijbelG276XTKUFiMeta || {},
    alias: bijbelG276XTKUFiMeta?.alias || [],
    redirect: bijbelG276XTKUFiMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/bijbel.vue").then(m => m.default || m)
  },
  {
    name: bijbelG276XTKUFiMeta?.name ?? "bijbel___fi-FI",
    path: bijbelG276XTKUFiMeta?.path ?? "/fi-FI/bijbel",
    meta: bijbelG276XTKUFiMeta || {},
    alias: bijbelG276XTKUFiMeta?.alias || [],
    redirect: bijbelG276XTKUFiMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/bijbel.vue").then(m => m.default || m)
  },
  {
    name: chatdYO1V9nj87Meta?.name ?? "chat___nl-NL",
    path: chatdYO1V9nj87Meta?.path ?? "/chat",
    meta: chatdYO1V9nj87Meta || {},
    alias: chatdYO1V9nj87Meta?.alias || [],
    redirect: chatdYO1V9nj87Meta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/chat.vue").then(m => m.default || m)
  },
  {
    name: chatdYO1V9nj87Meta?.name ?? "chat___fi-FI",
    path: chatdYO1V9nj87Meta?.path ?? "/fi-FI/chat",
    meta: chatdYO1V9nj87Meta || {},
    alias: chatdYO1V9nj87Meta?.alias || [],
    redirect: chatdYO1V9nj87Meta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/chat.vue").then(m => m.default || m)
  },
  {
    name: compare_45modelsaIpYM6owMLMeta?.name ?? "compare-models___nl-NL",
    path: compare_45modelsaIpYM6owMLMeta?.path ?? "/compare-models",
    meta: compare_45modelsaIpYM6owMLMeta || {},
    alias: compare_45modelsaIpYM6owMLMeta?.alias || [],
    redirect: compare_45modelsaIpYM6owMLMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/compare-models.vue").then(m => m.default || m)
  },
  {
    name: compare_45modelsaIpYM6owMLMeta?.name ?? "compare-models___fi-FI",
    path: compare_45modelsaIpYM6owMLMeta?.path ?? "/fi-FI/compare-models",
    meta: compare_45modelsaIpYM6owMLMeta || {},
    alias: compare_45modelsaIpYM6owMLMeta?.alias || [],
    redirect: compare_45modelsaIpYM6owMLMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/compare-models.vue").then(m => m.default || m)
  },
  {
    name: feedbackmHcH3RsfWFMeta?.name ?? "feedback___nl-NL",
    path: feedbackmHcH3RsfWFMeta?.path ?? "/feedback",
    meta: feedbackmHcH3RsfWFMeta || {},
    alias: feedbackmHcH3RsfWFMeta?.alias || [],
    redirect: feedbackmHcH3RsfWFMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackmHcH3RsfWFMeta?.name ?? "feedback___fi-FI",
    path: feedbackmHcH3RsfWFMeta?.path ?? "/fi-FI/feedback",
    meta: feedbackmHcH3RsfWFMeta || {},
    alias: feedbackmHcH3RsfWFMeta?.alias || [],
    redirect: feedbackmHcH3RsfWFMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/feedback.vue").then(m => m.default || m)
  },
  {
    name: indexbbHPdvO9QxMeta?.name ?? "index___nl-NL",
    path: indexbbHPdvO9QxMeta?.path ?? "/",
    meta: indexbbHPdvO9QxMeta || {},
    alias: indexbbHPdvO9QxMeta?.alias || [],
    redirect: indexbbHPdvO9QxMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexbbHPdvO9QxMeta?.name ?? "index___fi-FI",
    path: indexbbHPdvO9QxMeta?.path ?? "/fi-FI",
    meta: indexbbHPdvO9QxMeta || {},
    alias: indexbbHPdvO9QxMeta?.alias || [],
    redirect: indexbbHPdvO9QxMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/index.vue").then(m => m.default || m)
  },
  {
    name: overkW9jEkzz7RMeta?.name ?? "over___nl-NL",
    path: overkW9jEkzz7RMeta?.path ?? "/over",
    meta: overkW9jEkzz7RMeta || {},
    alias: overkW9jEkzz7RMeta?.alias || [],
    redirect: overkW9jEkzz7RMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/over.vue").then(m => m.default || m)
  },
  {
    name: overkW9jEkzz7RMeta?.name ?? "over___fi-FI",
    path: overkW9jEkzz7RMeta?.path ?? "/fi-FI/over",
    meta: overkW9jEkzz7RMeta || {},
    alias: overkW9jEkzz7RMeta?.alias || [],
    redirect: overkW9jEkzz7RMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/over.vue").then(m => m.default || m)
  },
  {
    name: test1cOkiTlZOsMeta?.name ?? "test___nl-NL",
    path: test1cOkiTlZOsMeta?.path ?? "/test",
    meta: test1cOkiTlZOsMeta || {},
    alias: test1cOkiTlZOsMeta?.alias || [],
    redirect: test1cOkiTlZOsMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/test.vue").then(m => m.default || m)
  },
  {
    name: test1cOkiTlZOsMeta?.name ?? "test___fi-FI",
    path: test1cOkiTlZOsMeta?.path ?? "/fi-FI/test",
    meta: test1cOkiTlZOsMeta || {},
    alias: test1cOkiTlZOsMeta?.alias || [],
    redirect: test1cOkiTlZOsMeta?.redirect,
    component: () => import("/vercel/path0/bible-assistant/pages/test.vue").then(m => m.default || m)
  }
]